import { useState } from "react";
import ProductStructuredReviews from "./ProductStructuredReviews";
import ProductGalery from "./ProductGalery";
import ProductInformations from "./ProductInformations";
import ProductSuggestions from "./ProductSuggestions";
import ProductRecentComments from "./ProductRecentComments";
import ProductReviewsOffcanvas from "./ProductReviewsOffCanvas";

function Product({ product, context }) {
  const [offcanvasOpened, setOffcanvasOpened] = useState(false);

  async function openCompleteReviews() {
    setOffcanvasOpened(true);
  }

  return (
    <div className="d-flex flex-grow-1 flex-column">
      <ProductStructuredReviews product={product} />

      <div className="product-container">
        <ProductGalery pictures={product.pictures} />

        <ProductInformations
          product={product}
          context={context}
          openCompleteReviews={openCompleteReviews}
        />
      </div>

      <ProductSuggestions
        product={product}
        context={context}
      />

      <ProductRecentComments
        product={product}
        openCompleteReviews={openCompleteReviews}
      />

      <ProductReviewsOffcanvas
        product={product}
        opened={offcanvasOpened}
        close={() => setOffcanvasOpened(false)}
      />
    </div>
  );
}

export default Product;